<template>
    <div class="report-pay-success-popup">
        <div class="report-pay-success" :class="'a'+sucNum"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportPaySuccess',
    data() {
        return {
            sucTime: 80, sucNum: 1,
        }
    },
    mounted() {
        setTimeout(function() {
            this.initAnimation();
        }.bind(this), 20);
    },
    methods: {
        initAnimation() {
            var me = this;
            function ani() {
                me.sucNum = me.sucNum == 16 ? 1 : me.sucNum+1;
                setTimeout(ani, me.sucTime)
            }
            ani();
        }
    }
}
</script>